import { gql } from '@apollo/client'

export const POINT_FRAGMENT = gql`
  fragment Point on Point {
    x
    y
    z
  }
`
